import axiosInstance from "../utils/axiosInstance";
import { TokenDecrypt } from "../utils/encryptionDecryption";
const mapToOptions = (data, labelKey = "name", valueKey = "code") => {
  return data.map((item) => ({ label: item[labelKey], value: item[valueKey] }));
};
export const getTopicFromServer = async (page = 1,pageSize = 10) => {
  try {
    const response = await axiosInstance.get(`topics?page=${page}&limit=${pageSize}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response && response.data && response.data.encryptedData) {
      const decryptedData = TokenDecrypt(response.data.encryptedData);
      return decryptedData.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching topics:", error);
    throw new Error("Failed to fetch topics");
  }
};

export const addTopic = async (topicData) => {
  try {
    const jsonData = Object.fromEntries(topicData.entries());
    const updatedJson = { ...jsonData, isEnable: true };
    const response = await axiosInstance.post("topics", updatedJson, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    console.error("Error adding Topics:", error);
    throw new Error("Failed add Topics");
  }
};

export const updateTopic = async (topicId, topicData) => {
  try {
    const jsonData = Object.fromEntries(topicData.entries());
    const response = await axiosInstance.put(`topics/${topicId}/update`, jsonData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating topic:", error);
    throw new Error("Failed to update topic");
  }
};

export const deleteTopic = async (id) => {
  try {
    const response = await axiosInstance.delete(`/topics/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Failed to delete topic.";
    console.error("Error in topic:", errorMessage);
    throw new Error(errorMessage);
  }
};